define('boxes/events/signUpEvent',[], function() {
    'use strict';

    var signUpEvent = {};
    signUpEvent.SLIDE_ICON = 'SLIDE_ICON';
    signUpEvent.ACCOUNT_DATA = 'ACCOUNT_DATA';
    signUpEvent.REGISTER_SUCCESS = 'REGISTER_SUCCESS';
    signUpEvent.SIGNUP_LOGIN = 'SIGNUP_LOGIN';
    return signUpEvent;
});
